import { render, staticRenderFns } from "./CommoditySelect.vue?vue&type=template&id=704c19b8&scoped=true"
import script from "./CommoditySelect.vue?vue&type=script&lang=ts"
export * from "./CommoditySelect.vue?vue&type=script&lang=ts"
import style0 from "./CommoditySelect.vue?vue&type=style&index=0&id=704c19b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c19b8",
  null
  
)

export default component.exports